<template>
    <v-dialog :value="shows" width="1280" persistent :fullscreen="$vuetify.breakpoint.mobile">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card light v-bind="{ loading }" tile class="d-flex flex-column" max-height="90vh" style="overflow: hidden">
            <v-card-title>
                <span> 자재명세서 수정 </span>

                <v-spacer />
                <v-icon @click="close">mdi-close</v-icon>
            </v-card-title>
            <v-divider />
            <v-card-text class="py-5" style="position: relative; flex: 0 1 auto; overflow-y: auto">
                <mes-bom-form v-model="form" />
                <v-fade-transition>
                    <v-overlay v-show="loading" absolute light color="white">
                        <v-progress-circular indeterminate size="100" width="5" color="primary" />
                    </v-overlay>
                </v-fade-transition>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn text color="primary" @click="save">저장</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { initManufacturingBom, initManufacturingBomRow } from "@/assets/variables";

import MesBomForm from "./mes-bom-form.vue";

const initForm = ({ bom, rows = [] } = {}) => ({
    bom: initManufacturingBom(bom),
    rows: rows.map(initManufacturingBomRow),
});

export default {
    components: {
        MesBomForm,
    },
    props: {
        ecoNo: { type: String, default: null },
        modelCode: { type: String, default: null },
        revision: { type: String, default: null },
        rank: { type: String, default: null },
    },
    data: () => ({
        form: initForm(),

        loading: false,
    }),
    computed: {
        shows() {
            return this.ecoNo && this.modelCode && this.revision && this.rank;
        },
        params() {
            let { ecoNo, modelCode, revision, rank } = this;
            return { ecoNo, modelCode, revision, rank };
        },
    },
    mounted() {
        if (this.shows) this.init();
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
    methods: {
        async init() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { params } = this;
                const { bom } = await api.console.mes.boms.get(params);
                const { rows } = await api.console.mes.boms.rows.gets(params);

                this.form = initForm({ bom, rows });
            } finally {
                this.loading = false;
            }
        },
        async save() {
            if (this.loading) return;
            else this.loading = true;

            try {
                await api.console.mes.boms.put({
                    ecoNo: this.form.bom.ECO_NO,
                    modelCode: this.form.bom.MODEL_CODE,
                    revision: this.form.bom.REVISION,
                    rank: this.form.bom.RANK,
                    ...this.form,
                });

                alert("업로드되었습니다");
                this.$emit("input");
                this.shows = false;
            } finally {
                this.loading = false;
            }
        },

        close() {
            const { ...query } = this.$route.query;

            delete query.ecoNo;
            delete query.modelCode;
            delete query.revision;
            delete query.rank;

            this.$router.push({ query });
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .text-align-right-field {
    & > .v-input__control > .v-input__slot > .v-text-field__slot > input {
        text-align: right !important;
    }
}
::v-deep .amount-field {
    & > .v-input__control > .v-input__slot {
        padding-right: 0 !important;
    }
    & > .v-input__control > .v-input__slot > .v-input__append-inner {
        margin: 1px 0 0;
    }
    & > .v-input__control > .v-input__slot > .v-input__append-inner > .v-text-field--solo {
        width: 58px !important;

        .v-input__slot {
            padding-right: 4px;
        }
        .v-select__selections {
            justify-content: center;

            > .v-select__selection {
                margin-right: 0;
            }

            > input {
                display: none;
            }
        }

        .v-input__control,
        .v-input__slot {
            background-color: transparent;
        }
        .v-input__append-inner {
            margin-top: 0;
            padding-left: 0;
        }
    }
}

::v-deep .v-text-field__details {
    margin-bottom: 0 !important;
}

::v-deep .w-100-px {
    width: 100px;
}
</style>
